import { useEffect } from 'react'
import { installFormKeyboardFocus } from '@/lib/form-keyboard-focus'

export function FormKeyboardFocus() {
  useEffect(() => installFormKeyboardFocus(), [])
  return null
}
